import React from 'react';
export function HowItWorks() {
  const phases = [{
    icon: '🔍',
    name: 'FASE 1 — DIAGNÓSTICO',
    days: 'Día 0',
    description: 'Identifica tu patrón de hiperactivación en 3 minutos con el Checklist de 20 ítems.'
  }, {
    icon: '⚡',
    name: 'FASE 2 — ESTABILIDAD',
    days: 'Días 1–7',
    description: 'Activa los 4 interruptores del descanso real. 7 minutos por noche.'
  }, {
    icon: '📈',
    name: 'FASE 3 — CONSOLIDACIÓN',
    days: 'Días 8–14',
    description: 'Ajusta según tu patrón. Mide tu progreso. Observa los cambios.'
  }, {
    icon: '♾️',
    name: 'FASE 4 — MANTENIMIENTO',
    days: 'Día 15+',
    description: 'Sostén resultados con solo 3 noches por semana.'
  }];
  const interruptors = [{
    color: '🔴',
    name: 'CUERPO',
    description: 'Libera la tensión muscular nocturna'
  }, {
    color: '🟡',
    name: 'RESPIRACIÓN',
    description: 'Activa el nervio vago'
  }, {
    color: '🟢',
    name: 'ATENCIÓN',
    description: 'Vacía la mente de pendientes'
  }, {
    color: '🔵',
    name: 'ENTORNO',
    description: 'Envía señales de seguridad al cerebro'
  }];
  return <section className="w-full bg-navy-light py-16 md:py-24 px-4" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-172">
          EL MÉTODO
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-173">
          El método en 4 fases:
        </h2>

        {/* Phase Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-174">
          {phases.map((phase, index) => <div key={index} className="bg-navy rounded-xl p-6" data-id="element-175">
              <span className="text-4xl mb-4 block" data-id="element-176">{phase.icon}</span>
              <h3 className="text-cyan font-bold text-lg mb-1" data-id="element-177">{phase.name}</h3>
              <p className="text-gray-400 text-sm mb-3" data-id="element-178">{phase.days}</p>
              <p className="text-white" data-id="element-179">{phase.description}</p>
            </div>)}
        </div>

        {/* Interruptors */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-180">
          {interruptors.map((item, index) => <div key={index} className="bg-navy rounded-lg p-4 border border-white/10" data-id="element-181">
              <p className="text-white" data-id="element-182">
                {item.color} <span className="font-bold" data-id="element-183">{item.name}</span> —{' '}
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}